export const COST_CENTER_EVENTS = {
  COST_CENTER_CREATE: "cost-center-create",
  COST_CENTER_UPDATE: "cost-center-update",
  COST_CENTER_DELETE: "cost-center-delete",
  COST_CENTER_STATUS_TOGGLE: "cost-center-status-toggle",
  COST_CENTER_FETCH: "cost-center-fetch",
};
